import React, { useEffect, useState } from 'react'
import { FormCombobox } from '../../CoForm'
import { Box } from '@material-ui/core'
import api from 'services/api'

export function ComboboxAdminCompanies({ ...props }) {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function fetchCompanies() {
      setLoading(true)
      try {
        const response = await api.get('/miscellaneous/admin_companies')

        const formatted = response.data.map((item) => ({
          value: item.cia_cgc,
          label: item.descr,
        }))

        setCompanies(formatted)
      } catch (error) {
        console.error('Erro ao buscar empresas:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchCompanies()
  }, [])

  return (
    <Box display="flex" gridGap="1rem">
      <FormCombobox
        options={companies}
        loading={loading}
        noOptionsText="Nenhuma empresa encontrada"
        loadingText="Carregando empresas..."
        {...props}
      />
    </Box>
  )
}

export default ComboboxAdminCompanies
